
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition de la notoriété de marque : l’agence ALEO vous l’explique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment développer la notoriété de votre marque, attirer l’attention de vos clients et renforcer votre position sur le marché grâce à des stratégies efficaces.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de la notoriété de marque : l’agence ALEO vous l’explique",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez comment développer la notoriété de votre marque, attirer l’attention de vos clients et renforcer votre position sur le marché grâce à des stratégies efficaces.",
        },
      ],
    };
  },
};
